import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store';
import { QueryClientProvider, QueryClient } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools'
import { ErrorBoundary } from "react-error-boundary";
import ExceptionPage from './pages/ExceptionPage/exceptionPage';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 0,
            refetchOnWindowFocus: false,
            cacheTime: Infinity,
        },
    },
});

const ApiUrl = process.env.REACT_APP_API_END_POINT;
root.render(
    <QueryClientProvider client={queryClient}>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                {ApiUrl?.includes('samiinco') ? <App /> : <ErrorBoundary
                    FallbackComponent={ExceptionPage}
                    onError={() => {
                        // setTimeout(() => {
                        //   window.location.href = "/";
                        // }, 3000);
                    }}
                >
                    <App />
                </ErrorBoundary>}

                <ReactQueryDevtools initialIsOpen={false} />
            </PersistGate>
        </Provider>
    </QueryClientProvider>
);


serviceWorkerRegistration.register({
    // onUpdate: (registration) => {
    //     if (registration.waiting) {
    //         toast.info("نسخه جدیدی موجود است. در حال آماده‌سازی برای به‌روزرسانی....", {
    //             autoClose: 3000,
    //             onClose: () => {
    //                 registration.waiting!.postMessage({ type: 'SKIP_WAITING' });
    //                 window.location.reload();
    //             }
    //         });
    //     }
    // }
});


reportWebVitals();
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
